import { maybeStr, obj, str } from "@agrigate/ts-utils/lib/zod";
import * as z from "zod/v4";
export const GeoLevel = z.enum([
    "regionId",
    "districtId",
    "blockId",
    "clusterId",
]);
export const GeoScopeRow = obj({
    regionId: maybeStr,
    districtId: maybeStr,
    blockId: maybeStr,
    clusterId: maybeStr,
});
export const AppliedGeoScope = obj({
    level: GeoLevel,
    ids: str.array(),
    scopes: GeoScopeRow.array(),
});
//# sourceMappingURL=geo-scope.js.map